var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.686334 3.2521C0.046105 2.68649 0.403172 1.62955 1.25541 1.56755L19.173 0.269025C19.9659 0.211613 20.4836 1.08329 20.0541 1.75258L10.3397 16.8641C9.878 17.5824 8.77851 17.3905 8.58824 16.5577L6.77762 8.6338L0.686334 3.2521ZM8.08872 8.60285L9.67178 15.5254L18.6258 1.59744L2.11072 2.79499L7.43297 7.49616L13.6627 3.79645C13.8093 3.70938 13.9845 3.68412 14.1497 3.72621C14.315 3.76831 14.4567 3.87431 14.5438 4.02091C14.6308 4.1675 14.6561 4.34268 14.614 4.50791C14.5719 4.67313 14.4659 4.81486 14.3192 4.90193L8.08949 8.60165L8.08872 8.60285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBtn);
export default __webpack_public_path__ + "static/media/sendBtn.7f76776719ad882469209de5be725b8c.svg";
export { ForwardRef as ReactComponent };